import "features/validationRules/components/Details.css";

import React, {useCallback, useState} from "react";
import {useNavigate} from "react-router-dom";

import {adminService} from "../services/adminService";
import {User} from "../types";
import {DataLoadingStatus} from "shared/types/common";
import {Role, useAuth} from "features/auth";
import UserDetailsCard from "./UserDetailsCard";

const UserDetails = ({activeUser, setActiveUser, setUserList}: {activeUser: User|undefined, setActiveUser: React.Dispatch<React.SetStateAction<User|undefined>>, setUserList: React.Dispatch<React.SetStateAction<User[]>>}) => {
    const { role, myUserId } = useAuth();
    const navigate = useNavigate();
    const [dataLoadingStatus, setDataLoadingStatus] = useState<DataLoadingStatus>(DataLoadingStatus.Loaded);

    const updateUserRole = useCallback((newRole: Role) => {
        const newUser: User = {...activeUser!, role: newRole};
        setActiveUser(newUser);
    }, [activeUser, setActiveUser]);

    const promUser = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm("Do you really want to promote this user?");
        if (confirmed) {
            adminService.promoteUser(activeUser!.user_id).then(resp => {
                if (resp.errorCode !== undefined) {
                    alert(`Error: ${resp.errorCode}`);
                    setDataLoadingStatus(DataLoadingStatus.Error);
                } else {
                    alert(resp.message);
                    if (resp.success) {
                        setUserList(resp.users!);
                        updateUserRole(activeUser!.role === Role.User? Role.Administrator : Role.SuperAdmin);
                    }
                }
            });
        }
    }, [setUserList, activeUser, updateUserRole]);

    const demUser = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm("Do you really want to demote this user?");
        if (confirmed) {
            adminService.demoteUser(activeUser!.user_id).then(resp => {
                if (resp.errorCode !== undefined) {
                    alert(`Error: ${resp.errorCode}`);
                    setDataLoadingStatus(DataLoadingStatus.Error);
                } else {
                    alert(resp.message);
                    if (resp.success) {
                        setUserList(resp.users!);
                        updateUserRole(activeUser!.role === Role.SuperAdmin? Role.Administrator : Role.User);
                    }
                }
            });
        }
    }, [setUserList, activeUser, updateUserRole]);

    const rmUser = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm("Do you really want to delete this user and all their data?");
        if (confirmed) {
            adminService.deleteUser(activeUser!.user_id).then(resp => {
                if (resp.errorCode !== undefined) {
                    alert(`Error: ${resp.errorCode}`);
                    setDataLoadingStatus(DataLoadingStatus.Error);
                } else {
                    alert(resp.message);
                    if (resp.success) {
                        setUserList(resp.users!);
                        setActiveUser(undefined);
                        navigate('/users');
                    }
                }
            });
        }
    }, [setUserList, activeUser, setActiveUser, navigate]);


    return (
        <div className="details-component scrollable">
            {activeUser === undefined?
                <p className="select-category-message">Select the user...</p> :
                <div className="details-wrapper">
                    <UserDetailsCard user={activeUser!}/>
                    <div className="category-actions-button-menu">
                        {activeUser?.role === Role.User || (role === Role.SuperAdmin && activeUser?.role !== Role.SuperAdmin)?
                            <div className="category-actions-button-wrapper">
                                <button className="button green-button"
                                        disabled={dataLoadingStatus === DataLoadingStatus.Loading}
                                        onClick={promUser}
                                >Promote</button>
                            </div> :
                        <></>}
                        {(activeUser?.role === Role.Administrator || activeUser?.role === Role.SuperAdmin) && role === Role.SuperAdmin?
                            <div className="category-actions-button-wrapper">
                                <button className="button red-button"
                                        disabled={dataLoadingStatus === DataLoadingStatus.Loading}
                                        onClick={demUser}
                                >Demote</button>
                            </div> :
                        <></>}
                        {myUserId !== activeUser!.user_id && (activeUser?.role === Role.User || role === Role.SuperAdmin)?
                            <div className="category-actions-button-wrapper">
                                <button className="button red-button"
                                        disabled={dataLoadingStatus === DataLoadingStatus.Loading}
                                        onClick={rmUser}
                                >Remove</button>
                            </div> :
                        <></>}
                    </div>
                    {dataLoadingStatus === DataLoadingStatus.Loading? <p className="info-text">It may take up to 5 minutes. Please, be patient and don't refresh the page!</p> : <></>}
                    {dataLoadingStatus === DataLoadingStatus.Error? <p className="error-text">Network error occurred! Please, reload the page and try again...</p> : <></>}
                    <div className="results-wrapper"></div>
                </div>
            }</div>
    );
};

export default UserDetails;
